import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { HomeService } from 'src/app/shared/services/home.service';
import { PerformanceTrackerService } from 'src/app/shared/services/performance-tracker.service';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';

@Component({
  selector: 'app-pt-event',
  templateUrl: './pt-event.component.html',
  styleUrls: ['./pt-event.component.scss']
})
export class PTEventComponent implements OnInit {
  pt_uuid: string;
  isEventDetailsloaded: boolean = false;
  private isPageReload = false;

  constructor(private sidePanelService:SidePanelService,
    private performanceService: PerformanceTrackerService,
    public homeService: HomeService,
    private notifier: NotifierService,
    private activatedRoute: ActivatedRoute,
    public router: Router
  ) { 
    this.isEventDetailsloaded = false;
    //  this.router.events.subscribe(event => {
    //   console.log('Router event:', event);
    //   console.log('Router event instanceof NavigationStart:', event instanceof NavigationStart);
    //   if (event instanceof NavigationStart) {
    //     this.navigationStarted = true;
    //   }
    // });
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((ptId) => { 
      this.pt_uuid = ptId.id; 
      this.isPageReload = (this.homeService.ptDetails && this.homeService.ptDetails.pt_uuid) ? false : true;
      this.resetEventPerformanceTracker();
    });
    if(!(this.homeService.ptDetails && this.homeService.ptDetails.pt_uuid)){
      this.getPtDetails();
    }else{
      this.isEventDetailsloaded = true;
    }
  }
  

  getPtDetails(){
    this.performanceService.getPtDetails(this.pt_uuid).subscribe((res:any)=>{
      if(res && res['status'] == 1){
        this.homeService.ptDetails = res['pt_details'];
        this.sidePanelService.initSideDrawer("PT");
        this.isEventDetailsloaded = true;
      }else{
        this.notifier.notify('error', res['message'] || 'Something went wrong!');
      }
    })
  }

  resetEventPerformanceTracker(){
    this.isEventDetailsloaded = false;
    setTimeout(() => {
      this.openEventsPerformanceTrackerInNewTab();
      this.isEventDetailsloaded = true;
    }, 1);
  }

  openEventsPerformanceTrackerInNewTab(){
    // const url = this.router.serializeUrl(
    //   this.router.createUrlTree(['/home/performance-tracker/', this.homeService.getPtEventStudyId()])
    // );
    // window.open(url, '_blank');
    

    if(!this.isPageReload){
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/home/performance-tracker/', this.homeService.getPtEventStudyId()])
      );
      window.open(url, '_blank');
    }else{
      this.isPageReload = false;
    }
  }

}
